import { useSelector } from 'react-redux';
import commonStrings from 'modules/common/strings';
import logoBlue from 'assets/images/logo-blue.svg';
import SectionDivider from '../SectionDivider';
import {
  Wrapper,
  LogoWrapper,
  Logo,
  ItemContainer,
  ItemLink,
  ItemWrapper,
  Item,
} from './Sidebar.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Sidebar = () => {
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);

  const sidebarItems = [
    {
      context: 'bulkOrder',
      name: commonStrings.sidebar.bulkOrderItemName,
      icon: '"\\e904"',
    },
  ];
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo src={logoBlue} alt={commonStrings.sidebar.logoImageAltText} />
      </LogoWrapper>
      <SectionDivider gap={56} />
      {sidebarItems.map(sidebarItem => {
        const isItemSelected = sidebarItem.context === context;
        return (
          <ItemContainer key={sidebarItem.context} pushToEnd={sidebarItem.pushToEnd}>
            <ItemLink to={`/${sidebarItem.context}`}>
              <ItemWrapper icon={sidebarItem.icon} selected={isItemSelected}>
                {sidebarItem.name && (
                  <>
                    <SectionDivider gap={6} />
                    <Item>{sidebarItem.name}</Item>
                  </>
                )}
              </ItemWrapper>
            </ItemLink>
          </ItemContainer>
        );
      })}
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Sidebar.propTypes = {};

Sidebar.defaultProps = {};

export default Sidebar;
